// extracted by mini-css-extract-plugin
export var copyableField = "_ms-4";
export var customerBadge = "_ms-0";
export var customerInfoTitle = "_ms-2";
export var details = "_ms-1";
export var dropdownContainer = "_ms-5";
export var dropdownImage = "_ms-6";
export var editAssigneeForm = "_ms-a";
export var editButton = "_ms-3";
export var email = "_ms-7";
export var hidden = "_ms-d";
export var input = "_ms-8";
export var saveButton = "_ms-b";
export var shopifyIcon = "_ms-c";
export var suggestionBadge = "_ms-e";
export var suggestionText = "_ms-f";
export var username = "_ms-9";